<template>
    <div>
        <div
            :class="{
                'dropdown-content': !inline,
                'dropdown-content-padded': !inline,
                'dropdown-content-select-fixed': !inline && fixedDropdown
            }">
            <label v-if="showLabel" class="typo__label" v-text="label"/>
            <multi-select
                ref="optionList"
                :class="{'multiselect--fixed': fixedDropdown}"
                placeholder="Select option"
                :options="options"
                label="label"
                track-by="value"
                :internal-search="asyncSearch"
                :show-labels="false"
                :preserve-search="false"
                :close-on-select="false"
                :hide-selected="true"
                v-model="selectedOptions"
                :multiple="true"
                @search-change="asyncFind"
                @input="inputEvent"
                @close="closeEvent"
                :loading="isLoading">
                <template slot="tag" slot-scope="props">
                    <span class="multiselect__tag" v-fs-block>
                        <span>{{ formatSelectedTag(props.option.value) }}</span>
                        <i aria-hidden="true" tabindex="1" @keydown.enter.prevent="props.remove(props.option)"
                           @mousedown.prevent="props.remove(props.option)" class="multiselect__tag-icon"></i>
                    </span>
                </template>
            </multi-select>
        </div>
        <slot v-if="$slots.footer" name="footer"/>
        <filter-footer v-else @update="updateFilter" @enter="addFilterIsHover = true" @leave="addFilterIsHover = false"/>
    </div>
</template>

<script>
    import MultiSelect from 'vue-multiselect';
    import _ from '@/common/helpers';
    import filterMixins from './filter-mixins';
    import FilterFooter from './filter-footer';

    export default {
        mixins: [filterMixins],
        components: {MultiSelect, FilterFooter},
        props: {
            label: {
                type: String,
                required: false,
                default: '',
            },
            inline: Boolean,
        },
        data() {
            return {
                selectedOptions: [],
                options: [],
                isLoading: false,
                addFilterIsHover: false,
            };
        },
        computed: {
            fixedDropdown() {
                return !this.inline;
            },
            showLabel() {
                return !!this.label;
            },
            filterOptions() {
                return this.filter.filter.options;
            },
            asyncSearch() {
                return this.filter.filter.options.options.source !== 'rebillyAPI';
            },
        },
        methods: {
            inputEvent() {
                if (this.inline || this.filter.filter.options.options.immediate) {
                    this.updateFilter();
                }
            },
            closeEvent() {
                if (this.addFilterIsHover) {
                    this.updateFilter();
                }
            },
            updateFilter() {
                const payload = this.adapter.getFilterPayload({
                    index: this.index,
                    filter: this.filter,
                    assign: {values: this.selectedOptions.map(option => option.value)},
                });
                /**
                 * @event Update
                 * @type {object}
                 */
                this.$emit('update', payload);
                this.$parent.$emit('request-popper-hide');
            },
            async restoreSelection() {
                if (this.filter.condition.values !== null
                    && Array.isArray(this.filter.condition.values)
                    && this.filter.condition.values[0].length) {
                    this.selectedOptions = this.filter.condition.values.map(item => ({value: item, label: item}));
                }
            },
            async asyncFind(query) {
                this.isLoading = true;
                try {
                    const options = await this.filterOptions.getAll(query);
                    this.options = options.filter(item => item.label && item.value);
                    if (!this.inline) {
                        this.$refs.optionList.activate();
                    }
                } catch (error) {
                    this.options = [];
                    // Todo: User error notification (intercom - toast message)
                } finally {
                    this.isLoading = false;
                }
            },
            formatSelectedTag(value) {
                return _.truncate(value, {limit: 11, dots: true});
            },
        },
        mounted() {
            this.restoreSelection();
            this.asyncFind();
        },
    };
</script>
